"use client";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { BASE_URL, request } from "../../../api/request.tsx";
import LoadingWrap from "../../../component/LoadingWrap.tsx";
import { GetList } from "../../../hook/getList.tsx";
import { FaPlus, FaMinus } from "react-icons/fa";

const validationSchemaRegister = Yup.object().shape({
  categoryName: Yup.string().required("Vui lòng điền tên danh mục"),
  categoryNameEn: Yup.string().required("Vui lòng điền tên danh mục tiếng Anh"),
  categoryNameKo: Yup.string().required("Vui lòng điền tên danh mục tiếng Hàn"),
  categoryType: Yup.number().required("Vui lòng chọn loại danh mục"),
});

const dataType: any = [
  {
    name: "4Cuts",
    nameEn: "4Cuts",
    key: "FC",
    nameKo: "4컷",
  },
  {
    name: "3Cuts",
    nameEn: "3Cuts",
    key: "TC",
    nameKo: "3컷",
  },
  {
    name: "6Cuts",
    nameEn: "6Cuts",
    key: "SC",
    nameKo: "6컷",
  },
  {
    name: "9Cuts",
    nameEn: "9Cuts",
    key: "NC",
    nameKo: "9컷",
  },

  // {
  //   name: "Small size",
  //   nameEn: "Small size",
  //   key: "TSH",
  //   nameKo: "스몰 사이즈",
  // },
  {
    name: "Big size",
    nameEn: "Big size",
    key: "B",
    nameKo: "빅 사이즈",
  },
  {
    name: "Profile size",
    nameEn: "Profile size",
    key: "P",
    nameKo: "프로필 사이즈",
  },
  {
    name: "Full size",
    nameEn: "Full size",
    key: "TH",
    nameKo: "풀 사이즈",
  },
  {
    name: "Free size",
    nameEn: "Free size",
    key: "F",
    nameKo: "프리 사이즈",
  },
];

interface IFormInput {
  categoryName: string;
  categoryNameEn: string;
  categoryNameKo: string;
  categoryType: number;
}

interface SubCategory {
  name: string;
  nameEn: string;
  key: string;
  nameKo: string;
}

const CreateCategoryFrame = (props: any) => {
  const navigate = useNavigate();
  const [isUpdate, setisUpdate] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [subCategories, setSubCategories] = useState<SubCategory[]>([]);
  const location = useLocation();
  const { item } = location.state || {};
  const [urlThumb, setUrlThumb] = useState<string>("");
  const [uploading, setUploading] = useState<boolean>(false);

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = useForm<IFormInput>({
    defaultValues: {
      categoryName: item?.categoryName || "",
      categoryNameEn: item?.categoryNameEn || "",
      categoryNameKo: item?.categoryNameKo || "",
      categoryType: item?.categoryType || 1,
    },
    resolver: yupResolver(validationSchemaRegister),
  });

  const notify = (title: string) => toast(title);

  const handelOnchange = (value: any, field: any) => {
    setValue(field, value.target.value);
  };

  const addSubCategory = () => {
    setSubCategories([
      ...subCategories,
      {
        name: "",
        nameEn: "",
        key: "",
        nameKo: "",
      },
    ]);
  };

  const removeSubCategory = (index: number) => {
    const newSubCategories = subCategories.filter((_, i) => i !== index);
    setSubCategories(newSubCategories);
  };

  const updateSubCategory = (
    index: number,
    field: keyof SubCategory,
    value: string,
  ) => {
    const newSubCategories = [...subCategories];
    newSubCategories[index] = { ...newSubCategories[index], [field]: value };
    setSubCategories(newSubCategories);
  };

  const addFromDataType = (dataItem: any) => {
    setSubCategories([...subCategories, dataItem]);
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    if (item) {
      setisUpdate(true);
      setIsActive(item?.isActive);
      setUrlThumb(item?.urlThumb || "");
      if (item?.subCategory) {
        setSubCategories(item.subCategory);
      }
    }
  }, [item]);

  const onSubmit = async (result: IFormInput) => {
    setLoading(true);

    const filteredSubCategories = subCategories.filter(
      (subCat) =>
        subCat.name.trim() !== "" ||
        subCat.nameEn.trim() !== "" ||
        subCat.key.trim() !== "" ||
        subCat.nameKo.trim() !== "",
    );

    if (isUpdate) {
      const updateBody = {
        categoryName: result.categoryName,
        categoryNameEn: result.categoryNameEn,
        categoryNameKo: result.categoryNameKo,
        categoryType: result.categoryType,
        subCategory: filteredSubCategories,
        isActive: isActive,
        urlThumb: urlThumb,
        id: item?.id,
      };

      const res = await request(
        "frame/edit-frame-category",
        updateBody,
        "POST",
      );
      if (res?.status === false) {
        notify(res?.message || "Đã có lỗi xảy ra");
      } else {
        notify(res?.message || "Cập nhật thành công!");
        setTimeout(() => {
          navigate("/admin/frame-category");
        }, 1500);
      }
    } else {
      const createBody = {
        categoryName: result.categoryName,
        categoryNameEn: result.categoryNameEn,
        categoryNameKo: result.categoryNameKo,
        categoryType: result.categoryType,
        subCategory: filteredSubCategories,
        urlThumb: urlThumb,
        isActive: isActive,
      };

      const res = await request(
        "frame/create-frameCategory",
        createBody,
        "POST",
      );
      if (res?.status === false) {
        notify(res?.message || "Đã có lỗi xảy ra");
      } else {
        notify(res?.message || "Tạo thành công!");
        navigate("/admin/frame-category");
      }
    }

    setLoading(false);
  };
  const handleUploadThumb = async (event: any) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setLoading(true);
    setUrlThumb(URL.createObjectURL(file));
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await fetch(`${BASE_URL}upload/upload`, {
        method: "POST",
        body: formData,
      });
      const resJson = await res.json();
      if (resJson?.success) {
        setUrlThumb(resJson?.data?.url);
      } else {
        setUrlThumb(item?.urlThumb || "");
        notify(resJson?.message || "Đã có lỗi xảy ra, vui lòng thử lại sau");
      }
    } catch (e) {
      setUrlThumb(item?.urlThumb || "");
      notify("Đã có lỗi xảy ra, vui lòng thử lại sau");
    }
    setLoading(false);
    event.target.value = "";
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none";
  const classLable = "font-semibold text-[pink]";

  return (
    <LoadingWrap active={loading}>
      <div className="text-center font-bold text-[pink] text-xl mb-6">
        {isUpdate ? "CẬP NHẬT DANH MỤC FRAME" : "THÊM DANH MỤC FRAME"}
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="max-w-2xl mx-auto">
        <div className="mb-4">
          <div className={classLable}>Tên danh mục</div>
          <input
            onChange={(value) => handelOnchange(value, "categoryName")}
            type="text"
            className={classInput}
            defaultValue={getValues("categoryName")}
          />
          <div>
            {errors?.categoryName ? (
              <text style={{ color: "red" }}>
                {errors.categoryName?.message}
              </text>
            ) : null}
          </div>
        </div>

        <div className="mb-4">
          <div className={classLable}>Tên danh mục Tiếng Anh</div>
          <input
            onChange={(value) => handelOnchange(value, "categoryNameEn")}
            type="text"
            className={classInput}
            defaultValue={getValues("categoryNameEn")}
          />
          <div>
            {errors?.categoryNameEn ? (
              <text style={{ color: "red" }}>
                {errors.categoryNameEn?.message}
              </text>
            ) : null}
          </div>
        </div>

        <div className="mb-4">
          <div className={classLable}>Tên danh mục Tiếng Hàn</div>
          <input
            onChange={(value) => handelOnchange(value, "categoryNameKo")}
            type="text"
            className={classInput}
            defaultValue={getValues("categoryNameKo")}
          />
          <div>
            {errors?.categoryNameKo ? (
              <text style={{ color: "red" }}>
                {errors.categoryNameKo?.message}
              </text>
            ) : null}
          </div>
        </div>
        <div className="mb-4">
          <div className={classLable}>Ảnh thumbnail</div>

          <div className="flex items-center gap-3">
            <label
              className={`bg-[pink] hover:bg-pink-400 text-white px-4 py-2 rounded-lg cursor-pointer transition-colors duration-200 ${
                uploading ? "opacity-60 pointer-events-none" : ""
              }`}
            >
              {uploading ? "Đang upload..." : "Chọn ảnh"}
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleUploadThumb}
              />
            </label>

            {urlThumb && (
              <button
                type="button"
                onClick={() => setUrlThumb("")}
                className="text-pink-500 hover:text-pink-700 text-sm"
              >
                Xóa ảnh
              </button>
            )}
          </div>

          {/* <input
            type="text"
            value={urlThumb}
            onChange={(e) => setUrlThumb(e.target.value)}
            className={`${classInput} mt-2`}
            placeholder="https://phototimevn.com/..."
          /> */}

          {urlThumb && (
            <img
              src={urlThumb}
              alt="thumbnail"
              className="mt-3 w-40 h-40 object-cover rounded-lg border border-[pink]"
            />
          )}
        </div>
        <div className="mb-6">
          <div className="flex items-center text-[pink] cursor-pointer">
            <div
              className="border-[1px] border-[pink] w-[1.5rem] h-[1.5rem] rounded-full mr-2 items-center justify-center flex"
              onClick={() => setIsActive(!isActive)}
            >
              {isActive && (
                <div className="bg-[pink] w-[1rem] h-[1rem] rounded-full"></div>
              )}
            </div>
            <p>Hoạt động</p>
          </div>
        </div>

        <div className="mb-6">
          <div className="flex justify-between items-center mb-4">
            <div className={classLable}>Danh mục con</div>
            <button
              type="button"
              onClick={addSubCategory}
              className="bg-[pink] hover:bg-pink-400 text-white px-3 py-2 rounded-lg flex items-center gap-2 transition-colors duration-200"
            >
              <FaPlus size={16} />
              Thêm mới
            </button>
          </div>

          <div className="mb-4">
            <div className="text-sm text-gray-600 mb-2">
              Thêm nhanh từ danh sách có sẵn:
            </div>
            <div className="flex flex-wrap gap-2">
              {dataType.map((dataItem: any, index: number) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => addFromDataType(dataItem)}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded text-sm transition-colors duration-200"
                >
                  {dataItem.name}
                </button>
              ))}
            </div>
          </div>

          {subCategories.map((subCat, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-4 mb-3 bg-gray-50"
            >
              <div className="flex justify-between items-center mb-3">
                <div className="font-medium text-gray-700">
                  Danh mục con {index + 1}
                </div>
                <button
                  type="button"
                  onClick={() => removeSubCategory(index)}
                  className="text-pink-500 hover:text-pink-700"
                >
                  <FaMinus size={16} />
                </button>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <div className="text-sm text-gray-600 mb-1">Tên (VN)</div>
                  <input
                    type="text"
                    value={subCat.name}
                    onChange={(e) =>
                      updateSubCategory(index, "name", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                    placeholder="Tên tiếng Việt"
                  />
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">Tên (EN)</div>
                  <input
                    value={subCat.nameEn}
                    onChange={(e) =>
                      updateSubCategory(index, "nameEn", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                    placeholder="Tên tiếng Anh"
                  />
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">Key</div>
                  <input
                    type="text"
                    value={subCat.key}
                    onChange={(e) =>
                      updateSubCategory(index, "key", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                    placeholder="Key"
                  />
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">Tên (KO)</div>
                  <input
                    type="text"
                    value={subCat.nameKo}
                    onChange={(e) =>
                      updateSubCategory(index, "nameKo", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                    placeholder="Tên tiếng Hàn"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <button
            type="submit"
            className="bg-[pink] hover:bg-pink-400 text-white py-3 px-8 rounded-lg font-medium transition-colors duration-200"
          >
            {isUpdate ? "Cập nhật danh mục" : "Tạo danh mục"}
          </button>
        </div>
      </form>

      <ToastContainer />
    </LoadingWrap>
  );
};

export default CreateCategoryFrame;
